import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchFiltrosGuardados,
  fetchReporteCustom,
  setColumnasMostradasReportesCustom,
  setColumnasSinMostrarReportesCustom,
} from "../../actions/indicadores";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Button, Card, Grid, Typography } from "@material-ui/core";
import BotonGuardarPdf from "./BotonGuardarPdf";
import "./ConsultasGrid.css";
import TableConsulta from "./TableConsulta";
import FilterListIcon from "@material-ui/icons/FilterList";
import FiltrosModalConsultas from "./FiltrosModalConsultas";
import { fetchSeccionales } from "../../actions/cbos/seccionales";
import { fetchProvincias } from "../../actions/cbos/provincias";
import { fetchLocalidades } from "../../actions/cbos/localidades";
import SaveIcon from "@material-ui/icons/Save";
import FiltrosGuardadosModal from "./FiltrosGuardadosModal";
import { GuardarFiltrosModal } from "./GuardarFiltrosModal";
import { useLocation } from "react-router";
import LoadingBeforeViewData from "../compartidos/LoadingBeforeViewData";
import ChipsFiltros from "./ChipsFiltros";
import { fetchCategorias } from "../../actions/cbos/categorias";
import {fetchMotivosBaja} from "../../actions/cbos/motivosBaja"
import { traerAfiliaciones } from "../../actions/abm/abmAfiliaciones";
import { areas } from "../../helpers/areas";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  small: {
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  headerBar: {
    justifyContent: "space-between",
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
  },
  GridDnD: {
    paddingTop: theme.spacing(1),
  },
  contenedorIzquierda: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    paddingRight: 2,
  },
  contenedorDerecha: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paperContainer: {
    paddingTop: 80,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  Destino: {
    marginBottom: 10,
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  divDestino: {
    display: "flex",
    overflow: "auto",
    flexDirection: "row",
    paddingTop: "0.5rem",
  },
  Tipografia: {
    textAlign: "center",
  },
  button: {
    marginRight: "0.5rem",
  },
}));

const ConsultasGrid = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();

  const [abrirModal, setAbrirModal] = useState(false);
  const [abrirModalGuardados, setAbrirModalGuardados] = useState(false);
  const [abrirModalGuardarFiltros, setAbrirModalGuardarFiltros] =
    useState(false);

  const columnasOrigen = useSelector(
    (state) => state.indicadores.columnasSinMostrarEnReportesCustom
  );
  const columnasDestino = useSelector(
    (state) => state.indicadores.columnasMostradasEnReportesCustom
  );

  const indicadoresDatos = useSelector(
    (state) => state.indicadores.reportesCustom
  );
  const indicadoresLoading = useSelector((state) => state.indicadores.loading);
  const filtrosGuardados = useSelector(
    (state) => state.indicadores.filtrosReportesCustom
  );

  const seccionales = useSelector((state) => state.seccionales.items);
  const provincias = useSelector((state) => state.provincias.items);
  const localidades = useSelector((state) => state.localidades.items);
  const motivoBaja = useSelector((state) => state.motivosBaja.items);

  const [localidadesFiltradas, setLocalidadesFiltradas] = useState([]);

  const { items: categorias } = useSelector((state) => state.categorias);
  const { items: tiposAfiliaciones } = useSelector((state) => state.tipoAfiliaciones);

  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);
  const { idSeccional: idSeccionalUsuario } = useSelector((state) => state.auth);

  useEffect(() => {
    if ( seccionales.length === 0 || provincias.length === 0 || categorias.length === 0  || motivoBaja === 0 ) {
      dispatch(fetchSeccionales());
      dispatch(fetchProvincias());
      dispatch(fetchCategorias());
      dispatch(fetchFiltrosGuardados());
      dispatch(traerAfiliaciones());
      dispatch(fetchLocalidades());
      dispatch(fetchMotivosBaja());
    }
    // eslint-disable-next-line
  }, []);

  
  useEffect(() => {
    dispatch(
      fetchReporteCustom(
        1,
        indicadoresDatos && indicadoresDatos.registrosPorPagina > 0
          ? indicadoresDatos.registrosPorPagina
          : 20,
        location.search,
        idAreaUsuario === areas.Seccional,
        idSeccionalUsuario
      )
    );
    // eslint-disable-next-line
  }, [location.search]);

  const handleGetReportesCustom = (pagina, filas) => {
    dispatch(fetchReporteCustom(pagina, filas, location.search, idAreaUsuario === areas.Seccional, idSeccionalUsuario));
  };

  function handleOnDragEnd(result) {
    const { source, destination, draggableId } = result;
    if (!result.destination) return;
    if (source.droppableId === destination.droppableId) {
      const items = Array.from(columnasOrigen);
      const items2 = Array.from(columnasDestino);

      if (source.droppableId === "characters") {
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        dispatch(setColumnasSinMostrarReportesCustom(items));
      }

      if (source.droppableId === "characters2") {
        const [reorderedItem2] = items2.splice(result.source.index, 1);
        items2.splice(result.destination.index, 0, reorderedItem2);
        dispatch(setColumnasMostradasReportesCustom(items2));
      }
    } else {
      const items = Array.from(columnasOrigen);
      const items2 = Array.from(columnasDestino);

      let obj = {};
      if (destination.droppableId === "characters2") {
        obj = items.find((x) => x.id === draggableId);
        const index = items.indexOf(obj);
        items.splice(index, 1);
        items2.push(obj);
      } else {
        obj = items2.find((x) => x.id === draggableId);
        const index = items2.indexOf(obj);
        items2.splice(index, 1);
        items.unshift(obj);
      }
      dispatch(setColumnasSinMostrarReportesCustom(items));
      dispatch(setColumnasMostradasReportesCustom(items2));
    }
  }

  if (
    /*indicadoresDatos === null ||*/ /* Se Muestran los filtros antes de que este el primer resultado*/
    filtrosGuardados === null ||
    seccionales.length === 0 ||
    provincias.length === 0 ||
    localidades.length === 0
  ) {
    return <LoadingBeforeViewData />;
  }
  const indicadoresDatosToTest = indicadoresDatos?.result
    ? indicadoresDatos?.result
    : [];
  console.log('indicadores datos:',indicadoresDatos);
  console.log(columnasOrigen)
  return (
    <div>
      <div className={classes.headerBar}>
        <div>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => setAbrirModalGuardados(true)}
            className={classes.button}
          >
            FILTROS GUARDADOS
          </Button>
        </div>
        <div>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => setAbrirModal(true)}
            className={classes.button}
            startIcon={<FilterListIcon />}
          >
            Filtros
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => setAbrirModalGuardarFiltros(true)}
            className={classes.button}
            startIcon={<SaveIcon />}
          >
            Guardar filtros
          </Button>
        </div>
        <BotonGuardarPdf
          columnsTable={columnasDestino}
          totalFilas={indicadoresDatos?.totalRegistros}
          esSeccional = {idAreaUsuario === areas.Seccional}
          idSeccional = {idSeccionalUsuario}
        />
      </div>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Grid className={classes.GridDnD} container spacing={1}>
          <Grid item xs={2}>
            <Paper className={classes.paper}>
              {" "}
              <div className={classes.contenedorIzquierda}>
                <Droppable droppableId="characters">
                  {(provided) => (
                    <ul
                      className="characters"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {columnasOrigen &&
                        columnasOrigen.map(({ id, name }, index) => {
                          return (
                            <Draggable key={id} draggableId={id} index={index}>
                              {(provided) => (
                                <li
                                  className="characters"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <p className="character-p">{name}</p>
                                </li>
                              )}
                            </Draggable>
                          );
                        })}
                      {provided.placeholder}
                    </ul>
                  )}
                </Droppable>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={10}>
            <Paper elevation={0} className={classes.Destino}>
              <Droppable droppableId="characters2" direction="horizontal">
                {(provided) => (
                  <ul
                    className="characters"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    <Typography className={classes.Tipografia}>
                      Seleccione los datos del menú de la izquierda que desea
                      visualizar y arrástrelos a este sector...
                    </Typography>
                    <div className={classes.divDestino}>
                      {columnasDestino.map(({ id, name }, index) => {
                        return (
                          <div style={{ marginLeft: 1, marginRight: 1 }}>
                            <Draggable key={id} draggableId={id} index={index}>
                              {(provided) => (
                                <li
                                  className="characters"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <p className="characters">{name}</p>
                                </li>
                              )}
                            </Draggable>
                          </div>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  </ul>
                )}
              </Droppable>
            </Paper>
            <Grid container style={{ paddingBottom: "0.5rem" }}>
              <Grid item xs={12} sm={4} style={{ paddingRight: "1rem" }}>
                <Card style={{ padding: "1rem" }}>
                  <Typography variant="h6">
                    <span style={{ fontWeight: "bold" }}>Total:</span>{" "}
                    {indicadoresDatos?.totalRegistros}
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4} style={{ paddingRight: "1rem" }}>
                <Card style={{ padding: "1rem" }}>
                  <Typography variant="h6">
                    <span style={{ fontWeight: "bold" }}>Titulares:</span>{" "}
                    {indicadoresDatos?.totalTitulares}
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card style={{ padding: "1rem" }}>
                  <Typography variant="h6">
                    <span style={{ fontWeight: "bold" }}>Familiares:</span>{" "}
                    {indicadoresDatos?.totalFamiliares}
                  </Typography>
                </Card>
              </Grid>
            </Grid>
            {/* Aca vamos a ver los filtros aplicados */}
            <ChipsFiltros 
              esSeccional = {idAreaUsuario === areas.Seccional}
              idSeccional = {idSeccionalUsuario} />
            <Paper>
              <TableConsulta
                data={indicadoresDatosToTest}
                columns={columnasDestino}
                paginaActual={indicadoresDatos?.pagina}
                registrosPorPagina={indicadoresDatos?.registrosPorPagina}
                totalRegistros={indicadoresDatos?.totalRegistros}
                ultimaPagina={indicadoresDatos?.ultimaPagina}
                loading={indicadoresLoading}
                handleGetReportesCustom={handleGetReportesCustom}
                categorias={categorias}
                motivoBaja={motivoBaja}
                tiposAfiliaciones={tiposAfiliaciones}
              />
            </Paper>
          </Grid>
        </Grid>
      </DragDropContext>
      <FiltrosModalConsultas
        abrirModal={abrirModal}
        setAbrirModal={setAbrirModal}
        seccionales={seccionales}
        provincias={provincias}
        allLocalidades={localidades}
        localidades={localidadesFiltradas}
        setLocalidades={setLocalidadesFiltradas}
        categorias={categorias}
        motivoBaja={motivoBaja}
        tiposAfiliaciones={tiposAfiliaciones}
        idAreaUsuario = {idAreaUsuario}
        idSeccionalUsuario = {idSeccionalUsuario}
      />
      <FiltrosGuardadosModal
        abrirModal={abrirModalGuardados}
        setAbrirModal={setAbrirModalGuardados}
        filtrosGuardados={filtrosGuardados}
      />
      <GuardarFiltrosModal
        abrirModal={abrirModalGuardarFiltros}
        setAbrirModal={setAbrirModalGuardarFiltros}
      />
    </div>
  );
};

export default ConsultasGrid;
